<template>
  <KakaoManagement />
</template>

<script>
import KakaoManagement from '@/views/KakaoManagement.vue'

export default {
  components: {KakaoManagement},
}
</script>
